export enum RequestsEnum {
  login = "auth/login",
  getCities = "get/cities",
  getExperiences = "experience/getExperiences",
  changeStatus = "experience/changeStatus",
}
